<template>
    <div class="steps-container">
        <div
            class="step"
            v-for="step in steps"
            :key="step.number"
            :class="getStepClass(step)"
        >
            <div>
                <loader-dots v-if="step.status === statusCurrentStep"></loader-dots>
                <div v-else class="circle" v-html="getStepStatusIcon(step)"></div>
            </div>
            <div>
                <div class="title">{{ step.title }}</div>
                <div class="caption" v-if="step.caption">{{ step.caption }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export const STEP_STATUS_SUCCESS = 'success';
    export const STEP_STATUS_FAILED = 'failed';
    export const STEP_STATUS_CURRENT = 'current';

    export default {
        props: {
            steps: {
                type: Array,
                default: () => ([{number: 1, title: 'First step', caption: 'First step caption', status: STEP_STATUS_CURRENT}])
            }
        },
        data() {
            return {
                statusCurrentStep: STEP_STATUS_CURRENT
            };
        },
        methods: {
            getStepStatusIcon(step) {
                if (step.status === STEP_STATUS_CURRENT || step.status === undefined) {
                    return step.number;
                } else if (step.status === STEP_STATUS_FAILED) {
                    return '<ion-icon name="close-outline"></ion-icon>';
                } else {
                    return '<ion-icon name="checkmark-outline"></ion-icon>';
                }
            },
            getStepClass(step) {
                if (step.status === STEP_STATUS_CURRENT) {
                    return 'current';
                } else if (step.status === STEP_STATUS_FAILED) {
                    return 'failed';
                } else if (step.status === STEP_STATUS_SUCCESS) {
                    return 'success';
                }

                return '';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .step {
        position: relative;
        min-height: 1em;
        color: gray;

        .title {
            line-height: 1.5em;
            font-weight: bold;
        }
        .caption {
            font-size: 0.8em;
        }

        & > div:first-child {
            position: static;
            height: 0;
        }

        & > div:not(:first-child) {
            margin-left: 1.5em;
            padding-left: 1em;
        }

        /* Circle */
        .circle {
            background: gray;
            position: relative;
            width: 1.5em;
            height: 1.5em;
            line-height: 1.5em;
            border-radius: 100%;
            color: #fff;
            text-align: center;
            box-shadow: 0 0 0 3px #fff;
            display: flex;
            justify-content: center;
            align-items: center;

            ion-icon {
                font-size: 1.17rem;
            }
        }

        /* Vertical Line */
        .circle:after {
            content: ' ';
            position: absolute;
            display: block;
            top: 1px;
            right: 50%;
            bottom: 1px;
            left: 50%;
            height: 100%;
            width: 1px;
            transform: scale(1, 2);
            transform-origin: 50% -100%;
            background-color: rgba(0, 0, 0, 0.25);
        }

        &.current {
            color: #4285f4;

            .circle {
                background-color: #4285f4;
            }
        }

        &.success {
            color: #358813;

            .circle {
                background-color: #358813;
            }
        }

        &.failed {
            color: #c32a2a;

            .circle {
                background-color: #c32a2a;
            }
        }

        & + .step {
            margin-top: 1.5em
        }

        &:last-child .circle:after {
            display: none
        }
    }
</style>
